module.exports = __webpack_public_path__ + "img/Coin.de90fa02.png";